'use strict';
var util = require('./util');

/**
 * @function
 * @desc applies custom scroll for all iscroll containers
 */
function initIScroll () {
	var scrollPrefix = 'iscroll-';
	$('.iscroll-wrapper').each(function (index) {
		if ($(this).hasClass('scroll')) {
			$(this).attr('id', scrollPrefix + index);
			var smartScroll = new IScroll(this, util.iscrollParams());
			$(this).bind('refresh', function () {
				var innerWrapperHeight = $(this).find('.inner-wrapper').height();
				var outerWrapperHeight = $(this).height();
				if (innerWrapperHeight < outerWrapperHeight) {
					$(this).removeClass('scroll');
				} else {
					$(this).addClass('scroll');
				}
				smartScroll.refresh();
			});
			$(this).imagesLoaded().always(function (instance) {
				$(instance.elements).trigger('refresh');
			});
		}
	});
}

exports.init = function () {
	initIScroll();
};